import React from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from 'vendor/x-data-grid'
import Pagination from '@mui/material/Pagination'
import { DATA_TABLE_OPTIONS } from '../../constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'

function GridPagination(_props) {
  const { pageSize } = _props

  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleRowsPerPageMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleRowsPerPageMenuClose = () => {
    setAnchorEl(null)
  }

  const handleRowsPerPageChange = React.useCallback(
    (option) => {
      apiRef.current.setPageSize(option)
      setAnchorEl(null)
    },
    [apiRef]
  )

  return (
    <>
      <div className="flex flex-row flex-grow justify-between items-center">
        <Pagination
          color="primary"
          count={pageCount}
          shape="rounded"
          page={page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />

        <Button
          variant="outlined"
          color="secondary"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleRowsPerPageMenuOpen}
          endIcon={<FontAwesomeIcon icon={open ? faCaretUp : faCaretDown} />}
        >
          Ver {pageSize} resultados
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleRowsPerPageMenuClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {DATA_TABLE_OPTIONS.rowPerPageOptions.map((option, index) => (
            <MenuItem
              key={index}
              onClick={() => handleRowsPerPageChange(option)}
            >
              <span className={pageSize === option ? 'active font-bold' : ''}>
                Ver {option} resultados
              </span>
            </MenuItem>
          ))}
        </Menu>
      </div>
    </>
  )
}

export default GridPagination
